import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApplicationDataApi, GetUpcomingLoanPaymentsResponse } from 'api/ApplicationDataApi';

import { ErrorResponse } from './ErrorResponse';

export const createGetUpcomingLoanPaymentsThunk = (api: ApplicationDataApi) =>
  createAsyncThunk('upcomingLoanPayments/getUpcomingLoanPayments', async (applicationId: string, thunkApi) => {
    try {
      const response: GetUpcomingLoanPaymentsResponse = await api.getUpcomingLoanPayments(applicationId);
      return response;
    } catch (error: unknown) {
      thunkApi.rejectWithValue((error as ErrorResponse).response.data);
      throw error;
    }
  });
